import type {ComponentRepository} from '../../repository/ComponentRepository'
// eslint-disable-next-line wix-editor/no-internal-import
import {type EditorElementLayout, LAYOUT} from '@wix/component-protocol/schema'
import type {Pointer} from '@wix/document-services-types'

export class LayoutBuilder {
    private readonly DEFAULT_LAYOUT: EditorElementLayout = {
        resizeDirection: LAYOUT.RESIZE_DIRECTION.horizontalAndVertical,
        disablePositioning: false,
        disableRotation: false,
        disableStretching: false
    }

    constructor(private readonly componentRepository: ComponentRepository) {}

    buildRootComponentLayoutManifest(componentPointer: Pointer) {
        const componentManifest = this.componentRepository.getManifestData(componentPointer)

        if (!componentManifest?.behavior?.resizable) {
            return {
                ...this.DEFAULT_LAYOUT,
                resizeDirection: LAYOUT.RESIZE_DIRECTION.none
            }
        }

        return this.DEFAULT_LAYOUT
    }
}
